import {
    USER_DATA, USER_TOKENS_DETAILS, SELECTED_SORT_VALUE, SELECTED_FILTER_VALUE, SELECTED_FILTER_ID, PAGE_SIZE_ON_NAVIGATION, SCROLL_OFFSET, CART_COUNT, CART_AMOUNT, CART_ID, APP_BANNER,
    ACF,ALL_CATEGORIES, ALL_SPECIAL_CATEGORIES, ALL_MERCHANTS, TILES
} from '../actions/types'

const INITIAL_STATE = {
    user: {},
    selectedFilter: "",
    selectedSort: "",
    cart_count: 0,
    cart_amount: 0,
    cart_id: "",
    app_banner:true,
    acf:{},
    allCategories:[],
    allMerchants:[],
    tiles:[]
}
const rootReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USER_DATA: {
            return {
                ...state,
                user: action.payLoad
            }
        }
        case USER_TOKENS_DETAILS: {
            return {
                ...state,
                user_tokens_details: action.payLoad
            }
        }
        case SELECTED_FILTER_VALUE: {
            return {
                ...state,
                selectedFilter: action.payLoad
            }
        }
        case SELECTED_SORT_VALUE: {
            return {
                ...state,
                selectedSort: action.payLoad
            }
        }
        case SELECTED_FILTER_ID: {
            return {
                ...state,
                selectedFilterId: action.payLoad
            }
        }
        case PAGE_SIZE_ON_NAVIGATION: {
            return {
                ...state,
                pageSizeOnNavigation: action.payLoad
            }
        }
        case SCROLL_OFFSET: {
            return {
                ...state,
                scrollOffset: action.payLoad
            }
        }
        case CART_COUNT: {
            return {
                ...state,
                cart_count: action.payLoad
            }
        }
        case CART_AMOUNT: {
            return {
                ...state,
                cart_amount: action.payLoad
            }
        }
        case CART_ID: {
            return {
                ...state,
                CART_ID: action.payLoad
            }
        }
        case APP_BANNER: {
            return {
                ...state,
                app_banner: action.payLoad
            }
        }
        case ACF: {
            return {
                ...state,
                acf: action.payLoad
            }
        }
        case ALL_CATEGORIES: {
            return {
                ...state,
                allCategories: action.payLoad
            }
        }
        case ALL_SPECIAL_CATEGORIES: {
            return {
                ...state,
                allSpecialCategories: action.payLoad
            }
        }
        case ALL_MERCHANTS: {
            return {
                ...state,
                allMerchants: action.payLoad
            }
        }
        case TILES: {
            return {
                ...state,
                tiles: action.payLoad
            }
        }
        default: {
            return {
                ...state
            }
        }
    }
}

export default rootReducers;